module.exports = __webpack_public_path__ + "static/media/04en.dc0cd57e.jpg";